import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import DangerBoxURL from 'components/1440p_Series_CGI_List/DangerBoxURL';
import IntroCards from 'components/1440p_Series_CGI_List/Network_Menu/networkCGI';
import NavButtons from 'components/1440p_Series_CGI_List/NavButtons';
import * as React from 'react';
export default {
  BreadCrumbs,
  SEOHelmet,
  DangerBoxURL,
  IntroCards,
  NavButtons,
  React
};